import { defineComponent as _defineComponent } from 'vue'
import OverviewDeviceCard from './OverviewDeviceCard.vue';
import OverviewDeviceCardStateKpi from './OverviewDeviceCardStateKpi.vue';
import { Device } from '@/models/device';
import {
  BendDeviceStateData,
  CurrentBendPlanData,
} from '@/models/deviceStateData';
import { isNil } from '@/utils/misc';
import { abbreviateNumber, abbreviateNumberWithUnit } from '@/utils/number';
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { formatTimeAgo } from '@/utils/dates';
import { currentCustomer } from '@/utils/permissionUtils';
import { CurrentBendPlanDataRetriever } from '@/models/Charts/currentBendPlanDataRetriever';
import OverviewDeviceCardKpiList from '@/components/workCenterConsole/OverviewDeviceCardKpiList.vue';
import OverviewDeviceCardKpi from '@/components/workCenterConsole/OverviewDeviceCardKpi.vue';
import { useInterval } from '@/composables/misc';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewNewBendDeviceCard',
  props: {
    device: null,
    deviceState: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  device: Device;
  /**
   * Object containing the information about state and metrics of the device.
   * Can be undefined if there is no data for the device.
   */
  deviceState: BendDeviceStateData | undefined;
};





const currentPlan = ref<CurrentBendPlanData | null>(null);
const isCurrentPlanLoading = ref(false);
const isFirstCurrentPlanLoad = ref(true);
const currentPlanDataRetriever = new CurrentBendPlanDataRetriever(
  currentCustomer()!.tenantIdDh,
);

const { t } = useI18n();

const now = inject<Ref<Date>>('now', () => ref(new Date()), true);

const hasCustomerDataPlatform = computed<boolean>(
  () => currentCustomer()!.hasDataPlatform,
);

if (hasCustomerDataPlatform.value) {
  useInterval(updateCurrentPlanData, 30);
}

onMounted(async () => {
  if (hasCustomerDataPlatform.value) {
    await updateCurrentPlanData();
    isFirstCurrentPlanLoad.value = false;
  }
});

async function updateCurrentPlanData() {
  try {
    currentPlanDataRetriever.abort();
    isCurrentPlanLoading.value = true;

    currentPlan.value = await currentPlanDataRetriever.getDataForDevice(
      props.device.deviceId,
    );
  } finally {
    isCurrentPlanLoading.value = false;
  }
}

const lastBendMessage = computed<string>(() => {
  if (!hasState) {
    return '';
  }

  const lastSeenUtc = new Date(props.deviceState!.lastState!);
  return formatTimeAgo(lastSeenUtc, now.value);
});

const hasState = computed<boolean>(() => !isNil(props.deviceState?.lastState));

const shouldShowCurrentPlan = computed<boolean>(
  () =>
    hasCustomerDataPlatform.value &&
    (!isNil(currentPlan.value) || isCurrentPlanLoading.value),
);

return { __sfc: true,props, emit, currentPlan, isCurrentPlanLoading, isFirstCurrentPlanLoad, currentPlanDataRetriever, t, now, hasCustomerDataPlatform, updateCurrentPlanData, lastBendMessage, hasState, shouldShowCurrentPlan, OverviewDeviceCard, OverviewDeviceCardStateKpi, abbreviateNumber, abbreviateNumberWithUnit, OverviewDeviceCardKpiList, OverviewDeviceCardKpi }
}

})